<template>
  <b-col
    class="card"
    :class="[inverted ? 'inverted' : '']"
  >
    <div
      v-if="header"
      class="multiply"
      :style="`background-color:${header.color};`"
    >
      {{ header.title }}
    </div>
    <div
      class="prices"
      :class="[publish ? 'card-publish' : '']"
      @click="$emit('selectTheRadio')"
    >
      <b-form-radio
        v-if="publish"
        v-model="radioSelect"
        class="radioInput"
        name="some-radios"
        :value="moreInfo"
      />
      <h2>{{ offerName }}</h2>
      <hr class="offer-hr">
      <div>
        <div>
          <span class="old-price">
            {{ oldPrice }}<span class="eur">€</span>
          </span>
        </div>
        <div>
          <span class="new-price">
            {{ newPrice }}<span class="eur">€ + IVA</span>
          </span>
        </div>
      </div>
      <b-button
        v-if="publish != true"
        class="btn-publish"
        @click="gotoPublishOffer"
      >
        {{ $t('cards.publish-offer.publish-now', 'Publish now') }}
      </b-button>
      <div
        v-b-toggle.collapse-3
        class="more-info-trigger"
      >
        <div v-if="isMoreInfoShow">
          {{ $t('cards.publish-offer.less-info', 'Less information') }}
          <font-awesome-icon icon="chevron-up" />
        </div>
        <div v-else>
          {{ $t('cards.publish-offer.more-info', 'More information') }}
          <font-awesome-icon icon="chevron-down" />
        </div>
      </div>
    </div>
    <b-collapse
      id="collapse-3"
      :visible="!publish"
    >
      <div v-if="footer">
        <div class="text-center font-weight-bold mt-2">
          {{ $t('cards.publish-offer.your-ad-on', 'Your ad on') }}
        </div>
        <li
          v-for="item in footer"
          :key="item.title"
          class="more-info-line"
        >
          {{ item.title }}
        </li>
      </div>
    </b-collapse>
  </b-col>
</template>

<script>
  export default {
    props: {
      inverted: {
        default: false,
        type: Boolean
      },
      oldPrice: {
        default: 0,
        type: Number
      },
      newPrice: {
        default: 0,
        type: Number
      },
      offerName: {
        default: '',
        type: String
      },
      moreInfo: {
        default: 'first',
        type: String
      },
      publish: {
        default: false,
        type: Boolean
      },
      radioSelect: {
        default: '',
        type: String
      },
      header: {
        default: null,
        type: Object,
      },
      footer: {
        default: () => [],
        type: Array,
      }
    },

    data() {
      return {
        isMoreInfoShow: false,
      }
    },

    mounted() {
      this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
        if (collapseId === 'collapse-3') {
          this.isMoreInfoShow = isJustShown
        }
      });

      if (this.$route.params.selected === this.moreInfo)
        this.$emit('selectTheRadio');
    },

    methods: {
      gotoPublishOffer() {
        // If company is verified!
        if (this.$auth.user().company.isVerified) {
          this.$router.push({name: 'publish-offer', params: {selected: this.moreInfo}});
        } else {
          this.$emit('shakeAlert');
        }
      }
    }
  }
</script>

<style lang="scss">
  .cards {
    margin: 0;
  }

  .card {
    margin: 20px 5px 5px;
    border: 1px solid #CCC !important;
    background: #f2f2f2;
    padding: 0;
    text-align: center;

    .prices {
      border: 1px solid #CCC;
      padding: 15px;
    }

    .btn-publish {
      text-transform: uppercase;
      font-size: 14px;
      font-weight: 600;
      border: 1px solid #658bc7;
      border-radius: 2px;
      background-color: #658bc7;
      padding: 10px 0;
      width: 80%;
      margin: 15px auto;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    }

    .offer-hr {
      background: black;
      width: 50%;
      margin: 0 auto 5px;
    }

    /*.row {*/
    /*    font-size: 1.8rem;*/
    /*    justify-content: space-evenly;*/
    /*}*/

    .old-price {
      text-decoration: line-through;
      text-decoration-thickness: 1px;
      font-size: 1.5rem;
      color: #999;
    }

    .new-price {
      font-weight: 600;
      font-size: 1.8rem;
    }

    .more-info-trigger {
      margin: 5px 0;
      font-size: 0.9rem;
      cursor: pointer;
    }

    .more-info-line {
      border-bottom: 1px solid #ccc;
      padding: 6px 6px 6px 30%;
      font-size: 0.95rem;
      text-align: left;
    }
  }

  .card.inverted {

    .prices {
      background: #009090;
      color: white;

      hr {
        background: white;
      }

      .btn-publish {
        color: #2d3133;
        border: 1px solid #f9e215;
        background-color: #f9e215;
      }
    }
  }

  .card-publish {
    cursor: pointer;

    .publishInfo {
      font-size: 0.8rem;
      margin: 10px;
      height: 40px;
    }
  }

  .multiply {
    width: 50%;
    height: 25px;
    position: relative;
    top: 0px;
    background: #47a974;
    margin: -12.5px auto;
    color: white;
    font-size: 0.8rem;
    padding-top: 3px;
    /*text-transform: uppercase;*/
  }

  .radioInput {
    margin: 10px;
  }

  .icon-info {
    border: 1px solid white;
    border-radius: 50%;
    padding: 2px;
    width: 15px !important;
    height: 15px;
    margin-top: 2px;
    cursor: pointer;
  }
</style>
